export default "__VITE_ASSET__445dc7ad__"